// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { AddInterventionComponent } from 'src/app/modules/interventions/pages/add-intervention/add-intervention.page';
import { InterventionDetailComponent } from 'src/app/modules/interventions/pages/intervention-detail/intervention-detail.page';
import { InterventionsListComponent } from 'src/app/modules/interventions/pages/interventions-list/interventions-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: InterventionsListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadInterventionsList'],
      roles: ['master', 'collaborator'],
    },
  },
  {
    path: 'detail/:interventionId',
    component: InterventionDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateInterventions'],
      roles: ['master', 'collaborator'],
    },
  },
  {
    path: 'add',
    component: AddInterventionComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateInterventions'],
      roles: ['master', 'collaborator'],
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class InterventionsRoutingModule { }
